var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',{attrs:{"isOpen":_vm.isOpen},on:{"closeModal":_vm.handleClose}},[_c('div',{staticClass:"payment-modal"},[_c('by-credit-card')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }